/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from './localization.service';

@Component({
  selector: 'gp-localization',
  template: ''
})
export class LocalizationComponent implements OnInit {

  // Resources that needs to be added when in RTL mode
  private rtlResources: any = [
    require('!raw-loader!sass-loader!../../../assets/bootstrap-rtl/bootstrap-rtl.scss'),
    require('!raw-loader!sass-loader!../../../stylesheets/app.rtl.scss')
  ];

  // Holders of <style> elements holding RTL resources
  private rtlStyles: Array<any> = [];

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2,
              private localization: LocalizationService,
              private translate: TranslateService) {
  }

  public ngOnInit() {
    this.renderer.setProperty(document.querySelector('html'), 'dir', 'ltr');
    this.translate.onLangChange.subscribe(event => this.setRtl());
  }

  public setRtl() {
    if (this.localization.isRtlLang()) {
      this.enableRtl();
    } else {
      this.disableRtl();
    }
  }

  public enableRtl() {
    this.rtlResources.forEach(resource => {
      const style = document.createElement('style');
      style.innerHTML = resource;
      this.elementRef.nativeElement.appendChild(style);
      this.rtlStyles.push(style);
      this.renderer.setProperty(document.querySelector('html'), 'dir', 'rtl');
    });
  }

  public disableRtl() {
    this.rtlStyles.forEach(style => {
      style.parentNode.removeChild(style);
    });
    this.rtlStyles = [];
    this.renderer.setProperty(document.querySelector('html'), 'dir', 'ltr');
  }
}
